import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {MessageService} from 'primeng/api';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class WebSocketService {
    private socket: WebSocket;
    private baseUrl: string;

    constructor(private keycloakService: KeycloakService, private messageService: MessageService) {
        if (environment.URL_DMP.startsWith('https')) {
            this.baseUrl = environment.URL_DMP.replace('https', 'wss');
        } else if (environment.URL_DMP.startsWith('http')) {
            this.baseUrl = environment.URL_DMP.replace('http', 'ws');
        }
    }

    public connect(userId: string): void {
        this.socket = new WebSocket(this.baseUrl + '/ws/messages?userId=' + userId);
        this.socket.onmessage = (event) => this.handleMessage(event);
        this.socket.onclose = (event) => {
            console.warn(`WebSocket closed: code=${event.code}, reason=${event.reason}`);
        };

        this.socket.onerror = (error) => {
            console.error('WebSocket error:', error);
        };
    }

    private handleMessage(event: MessageEvent): void {
        const message = JSON.parse(event.data);
        if (message.type === 'logout') {
            this.messageService.add({
                key: 'common',
                severity: 'warn',
                summary: 'Déconnexion forcée',
                detail: 'Vous avez été déconnecté par un administrateur. Vous allez être renvoyé vers la page de connexion.'
            });
            setTimeout(() => {
                this.logoutUser();
            }, 5000);
        }
    }

    private logoutUser(): void {
        this.keycloakService.clearToken();
        this.keycloakService.logout();
    }
}
